import { Notify } from 'quasar'
import ApiService from "@services/api.service";

//Gere les requettes dédié a l'ensemble des sessions calculé grâce à des controllers
export const antenneSessions = {
  state:{
    sessions: [],
    session: null,
  },
  mutations:{
    setAllSessions(state, sessions){
      state.sessions = sessions;
    },
    setSession(state, session){
      state.sessions= session;
    },
  },
  actions:{
    async fetchAllSessions(context){
      try{
        const response =  await ApiService.getRequest('/get_sessions_actives');
        context.commit('setAllSessions', response.data);

      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de la récupération des sessions",
          color: 'red'
        })
      }

    }
  },
  getters: {
    getAllSessions(state){
      return state.sessions;
    },
    getOneSession(state){
      return state.session;
    },
  }
}
